export default __webpack_public_path__ + "static/media/monsta-icon-full.47edac1e.svg";